module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-chalk-1-2c8baee00badaafa3c660d3af8c10dff.png";